import { PageLogin, signInWithGoogle } from '@sloyd/auth';
import { useMemo } from 'react';

export function LoginContainer() {
  const callbacks = useMemo(
    () => ({
      onLogin: () => {
        signInWithGoogle();
      },
    }),
    []
  );

  return <PageLogin onClick={callbacks.onLogin} />;
}
